import React from 'react'
import '../contact/contact.css'
import Facebook from '../../assets/facebook.png'
import Instagram from '../../assets/instagram.png'
import Twitter from '../../assets/twitter.png'
import { motion } from 'framer-motion';

const Contact = () => {
  return (
    <motion.div className='contact' 
    initial={{opacity: 0}}
    whileInView={{opacity: 1}}
    viewport={{once: true}} >
      <div className="c-left">
        <div className="c-name">
          <img src={require('../../assets/contact.jpg')} alt="" />
        </div>
      </div>
      <div className="c-right">
          <h2>Contact Us</h2> 
          <div className="contactInfo">
            <h3>Carrer Arribau, 750</h3>
            <h3>08015</h3>
            <h3>+34 677859412</h3>
            <h3>info@goya.com</h3>
            <a href="https://glovoapp.com/es/es/" target="_blank" rel="noreferrer">
          <img className='glovo' src="https://upload.wikimedia.org/wikipedia/commons/c/c6/Glovo_logo.png" alt="glovo" />
          </a>
          <div className="contact-media">
        <ul class="social-contact">
            <li><a href="https://facebook.com" target='_blank' rel="noreferrer"><img src={Facebook} alt='Facebook'/></a></li>
            <li><a href="https://instagram.com" target='_blank' rel="noreferrer"><img src={Instagram} alt='Facebook'/></a></li>
            <li><a href="https://twitter" target='_blank' rel="noreferrer"><img src={Twitter} alt='Facebook'/></a></li>
        </ul>
    </div>
          </div>                   
      </div>
    </motion.div>
  )
}

export default Contact